module.exports = __webpack_public_path__ + "media/Barrett's esophagus.b136ae87.wav";